module.exports = __webpack_public_path__ + "img/shape_round_checked.5057e00b.png";